import { render, staticRenderFns } from "./file-sharing-status.vue?vue&type=template&id=6da9bda3&scoped=true"
import script from "./file-sharing-status.vue?vue&type=script&lang=js"
export * from "./file-sharing-status.vue?vue&type=script&lang=js"
import style0 from "./file-sharing-status.vue?vue&type=style&index=0&id=6da9bda3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da9bda3",
  null
  
)

export default component.exports